import React, { useEffect } from "react"
import MetaTags from 'react-meta-tags';

//Import Action to copy breadcrumb items from local state to redux state
const Dashboard = (props) => {

  return (
    <React.Fragment>

      <MetaTags>
        <title>Dashboard | Lexa - Responsive Bootstrap 5 Admin Dashboard</title>
      </MetaTags>

    </React.Fragment>
  )
}

export default Dashboard;